import React, { useState, useEffect } from 'react';
// import { AuthCheckUser } from '../../Utils/AuthCheck/UserCheck.auth';
import PropTypes from 'prop-types';
import { FormContainer } from '../../AdminRoutes/CreateRoutes/CreateForm.styles';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
import BreadCrumbs from '../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import CheckoutInnerPage from './CheckoutInner.component';
import CartDataProvider from '../../Utils/Users/CartDataProvider';
import PrimaryButtonComponent from '../../Components/Buttons/PrimaryButton/PrimaryButton.component';

function Message({ content }) {
  return <p>{content}</p>;
}
Message.propTypes = {
  content: PropTypes.string,
};

// Main outer component for the purchase page
function BuyPage() {
  const [mergeNotice, setMergeNotice] = useState(false);

  useEffect(() => {
    try {
      const flag = sessionStorage.getItem('guest_cart_merged');
      if (flag) setMergeNotice(true);
    } catch (e) {
      // ignore
    }
  }, []);

  const dismissMergeNotice = () => {
    try {
      sessionStorage.removeItem('guest_cart_merged');
    } catch (e) {
      // ignore
    }
    setMergeNotice(false);
  };
  return (
    // <AuthCheckUser>
    <main>
      <HelmetHelper
        title="Checkout"
        description="Review your order and complete your purchase."
        noIndex
      />
      <FormContainer>
        {mergeNotice && (
          <div
            style={{
              background: '#fff3bf',
              border: '1px solid #ffe58f',
              padding: '12px',
              marginBottom: '16px',
              borderRadius: '4px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div>
              Items in your cart may have been adjusted — please review them.
            </div>
            <button onClick={dismissMergeNotice} style={{ marginLeft: '12px' }}>
              Dismiss
            </button>
          </div>
        )}
        <BreadCrumbs
          one="Online Training"
          oneLink={`/training`}
          two={`Review & Checkout`}
        />
        <CartDataProvider>
          {(cart) => (
            <>
              {cart?.length > 0 ? (
                <CheckoutInnerPage courses={cart} />
              ) : (
                <div>
                  <Message content="Your cart is empty" />
                  <PrimaryButtonComponent
                    span="Explore Courses"
                    functionName={() => (window.location.href = '/training')}
                  />
                </div>
              )}
            </>
          )}
        </CartDataProvider>
      </FormContainer>
      {/* // </AuthCheckUser> */}
    </main>
  );
}

export default BuyPage;
